<div class="sticky top-16 z-[30] bg-white pb-2">
  <nav compact tuiSubheader class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
      <ng-container *ngFor="let item of breadcrumbs; let last = last">
        <ng-container *ngIf="last">
          <strong *tuiItem tuiFade>
            {{ item }}
          </strong>
        </ng-container>
        <ng-container *ngIf="!last">
          <button *tuiItem tuiLink type="button">
            {{ item }}
          </button>
        </ng-container>
      </ng-container>
    </tui-breadcrumbs>
  </nav>

  <div class="items-center flex justify-between">
    <p class="text-[1.25rem] font-bold mt-[0.9rem] text-[#000000A6]">Nurses</p>
    <div>
      <button [routerLink]="['/admin/nurse/add-edit']" size="s" tuiButton type="button"
        [appDisableUnlessPermission]="'NURSE_CREATE'">
        Add New Nurse
      </button>
      <span style="margin: 5px;"></span>
      <button [routerLink]="['/admin/check-in']" size="s" tuiButton type="button"
        [appDisableUnlessPermission]="'SHIFT_CREATE'">
        Schedule a Shift
      </button>
    </div>
  </div>

  <!-- Top Row: Search Inputs (Search, Status, Availability) -->
  <div class="flex items-center space-x-4 mb-4">
    <div class="w-[431px]">
      <tui-textfield iconStart="@tui.search" tuiTextfieldSize="m">
        <input [(ngModel)]="filters.searchText" (keydown)="onEnter($event)" placeholder="Search Nurses" tuiTextfield />
      </tui-textfield>
    </div>

    <!-- Status dropDown -->
    <div class="w-[180px]">
      <tui-combo-box tuiTextfieldSize="m" [stringify]="stringify" [(ngModel)]="filters.status"
        (ngModelChange)="applyFilters({ status: filters.status })">
        Status
        <input tuiTextfieldLegacy placeholder="Select status" [value]="stringify(filters.status)" />
        <tui-data-list-wrapper *tuiDataList [items]="statusItems" [itemContent]="stringify | tuiStringifyContent" />
      </tui-combo-box>
    </div>

    <!-- Availability dropDown -->
    <div class="w-[180px]">
      <tui-combo-box tuiTextfieldSize="m" [stringify]="stringify" [(ngModel)]="filters.availability"
        (ngModelChange)="applyFilters({ availability: filters.availability })">
        Availability
        <input tuiTextfieldLegacy placeholder="Availability" [value]="stringify(filters.availability)" />
        <tui-data-list-wrapper *tuiDataList [items]="availabilityItems"
          [itemContent]="stringify | tuiStringifyContent" />
      </tui-combo-box>
    </div>

    <!-- Employment Type dropDown -->
    <div class="w-[180px]">
      <tui-combo-box tuiTextfieldSize="m" [(ngModel)]="filters.employmentType"
        (ngModelChange)="applyFilters({ employmentType: filters.employmentType })">
        Employment Type
        <input tuiTextfieldLegacy placeholder="Employment Type" [value]="filters.employmentType || ''" />
        <tui-data-list-wrapper *tuiDataList [items]="employmentTypeItems" />
      </tui-combo-box>
    </div>

    <button (click)="loadNurses()" appearance="secondary" size="m" tuiButton type="button" class="w-full sm:w-auto"
      style="border: 2px solid #e5e7ea; font-weight: 800">
      Search
    </button>
  </div>
</div>

<!-- Main Container -->
<section class="w-full">

  <!-- Bottom Row: Results Info (Left) and Archive Toggle (Right) -->
  <div class="flex items-center justify-between w-full">
    <!-- Left Side: Result Text & Clear Button -->
    <div class="flex items-center space-x-4">
      <p class="text-sm font-semibold text-[#26293C] my-0">
        Showing results for "{{ filters.searchText || "All Nurses" }}"
      </p>
      <button appearance="flat" iconStart="@tui.rotate-cw" size="xs" tuiButton type="reset" (click)="clearSearch()">
        Clear
      </button>
    </div>

    <!-- Right Side: Archived Toggle pulled to the end -->
    <div class="flex items-center space-x-2">
      <p class="text-sm font-medium text-[#191C30E5] my-0">Show Archived</p>
      <input title="Archived switch" tuiSwitch type="checkbox" [(ngModel)]="filters.archived"
        (change)="applyFilters({ archived: filters.archived })" />
    </div>
  </div>
</section>

<div *ngIf="isLoading" class="h-[400px]">
  <tui-loader />
</div>

<div *ngIf="!isLoading" class="w-full mt-5 overflow-x-scroll">
  <table tuiTable [size]="size" [style.width.rem]="120">
    <thead>
      <tr>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Employee Number
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Name
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Email
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Contact Number
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Status
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Employment Type
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Permanent Status
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Service Period
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Created Date
        </th>
        <th tuiTh style="padding: 0; padding-left: 10px; background-color: #f9fbff;z-index: -10;">
          Actions
        </th>
      </tr>
    </thead>

    <tbody tuiTbody>
      <tr *ngFor="let nurse of nurseData" [class.pending-permanent-row]="formatEmploymentStatus(nurse) === 'Pending'"
        [routerLink]="['/admin/nurse/', nurse._id]" class="text-[#526ED3] text-sm cursor-pointer">
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <div class="w-[10px] h-[10px] rounded-full" [style.background-color]="
                nurse.availability ? '#52D3C4' : '#FF6B6B'
              "></div>
            <p class="text-[#526ED3]">
              {{ getNurseEmployeeNumber(nurse) }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size" class="flex items-center gap-2 flex-wrap">
            <p class="text-[#191C30E5] text-sm m-0">{{ nurse.name }}</p>
            <!-- <span
              *ngIf="isEligibleForPermanent(nurse)"
              class="eligible-badge"
              title="Actual Join Date + 6 months reached. Open profile to Approve, Pending, or Reject."
            >
              Eligible for Permanent Nurse
            </span> -->
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ nurse.email }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ nurse.contactNo }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <p class="text-center w-[75px] px-2 py-0.5 rounded-full text-white"
            [style.background-color]="nurse.active ? '#6BC68A' : 'red'">
            {{ nurse.active ? "Active" : "Inactive" }}
          </p>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <span class="employment-type-pill"
              [ngClass]="(nurse.employmentType || 'Casual') === 'Permanent' ? 'type-permanent' : 'type-casual'">
              {{ nurse.employmentType || 'Casual' }}
            </span>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <span class="employment-status-pill" [ngClass]="getEmploymentStatusClass(nurse)">
              {{ formatEmploymentStatus(nurse) }}
            </span>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <p class="text-center min-w-[100px] px-3 py-0.5 rounded-full text-black whitespace-nowrap inline-block"
            [style.background-color]="getServiceDurationColor(nurse.registrationDate)">
            {{ getServicePeriodDisplay(nurse.registrationDate) }}
          </p>
        </td>

        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ nurse.createdAt | date : "MMM d, y" }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <span tuiStatus>
            <p [routerLink]="['/admin/nurse/', nurse._id]"
              class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer">
              View
            </p>
            <button [routerLink]="['/admin/nurse/add-edit', nurse._id]" [disabled]="nurse?.archived" [style.color]="
                nurse?.archived
                  ? '#a6afce'
                  : loggedInUserCanEdit
                  ? '#526ED3'
                  : '#a6afce'
              "
              class="appearance-none bg-white border-none pt-[3px] m-0 text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer">
              Edit
            </button>
            <div>
              <button appearance="action" iconStart="@tui.ellipsis" size="xs" tuiIconButton type="button"
                [tuiAppearanceState]="openMap[nurse._id] ? 'hover' : null" [tuiDropdown]="content"
                [disabled]="!loggedInUserCanEdit" [style.color]="!loggedInUserCanEdit ? '#a6afce' : '#526ED3'"
                [(tuiDropdownOpen)]="openMap[nurse._id]" (click)="toggleDropdown(nurse._id)">
                More
              </button>
              <ng-template #content>
                <tui-data-list tuiDataListDropdownManager [size]="openDropdownsize">
                  <button style="color: black" class="dropdown-button" tuiOption type="button"
                    (click)="resetUserPassword(nurse?.email)">
                    Reset Password
                  </button>
                  <button style="color: black" class="dropdown-button" tuiOption type="button"
                    (click)="toggleActive(nurse?._id)">
                    {{ nurse?.active ? "Deactivate" : "Activate" }}
                  </button>
                  <button style="color: black" class="dropdown-button" tuiOption type="button"
                    (click)="toggleArchive(nurse?._id)">
                    {{ nurse?.archived ? "Unarchive" : "Archive" }}
                  </button>
                </tui-data-list>
              </ng-template>
            </div>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Pagination Controls -->
<div class="flex justify-end items-center mt-5">
  <tui-pagination [index]="pageIndex - 1" [length]="getPageCount()" (indexChange)="onPageChange($event + 1)">
  </tui-pagination>
</div>